(function () {
  'use strict';

  function hydrateCountryList() {
    document.querySelectorAll('[data-gf-defer-countries]').forEach(function (wrapper) {
      if (wrapper.dataset.gfCountriesHydrated) return;
      var template = wrapper.querySelector('template[data-gf-country-template]');
      var target = wrapper.querySelector('ul.countries');
      if (!template || !target) return;
      target.appendChild(template.content.cloneNode(true));
      wrapper.dataset.gfCountriesHydrated = 'true';
    });
  }

  function initDrawerDefer() {
    document.querySelectorAll('drawer-localization-component details, .drawer-localization').forEach(function (el) {
      el.addEventListener('toggle', function () {
        if (el.open) hydrateCountryList();
      }, { passive: true });
    });
  }

  function initSectionLoader() {
    var sections = document.querySelectorAll('[data-gf-lazy-section]');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-hydrated');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    sections.forEach(function (section) { observer.observe(section); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDrawerDefer();
      initSectionLoader();
    });
  } else {
    initDrawerDefer();
    initSectionLoader();
  }
})();
